export interface IMeshBounds {
  width: number;
  height: number;
  depth: number;
  offsetX?: number;
  offsetY?: number;
  offsetZ?: number;
}

/**
 * Persisted `materialOverride` values use the `__mesh_*` scheme (plus any other keys from
 * `manufacturer.materials`). Missing or empty string is treated like
 * {@link MESH_INFO_MATERIAL_ORIGINAL_KEY} in the mesh editor.
 */
export const MESH_INFO_MATERIAL_ORIGINAL_KEY = "__mesh_original_material__";
export const MESH_INFO_MATERIAL_ALUMINUM_KEY = "__mesh_material_aluminum__";
export const MESH_INFO_MATERIAL_NORMALS_KEY = "__mesh_material_normals__";

/** Maps missing/empty override to explicit {@link MESH_INFO_MATERIAL_ORIGINAL_KEY}; otherwise unchanged. */
export function normalizeMeshInfoMaterialOverrideKey(
  raw: string | undefined | null,
): string {
  if (raw == null || raw === "") {
    return MESH_INFO_MATERIAL_ORIGINAL_KEY;
  }
  return raw;
}

/** True when `materialOverride` means original GLTF materials. */
export function isMeshInfoOriginalMaterial(
  materialOverride: string | undefined | null,
): boolean {
  if (materialOverride == null || materialOverride === "") {
    return true;
  }
  return materialOverride === MESH_INFO_MATERIAL_ORIGINAL_KEY;
}

// biome-ignore lint/suspicious/noExplicitAny: mesh transform shape varies by editor
export interface IMeshInfo<TransformType = any> {
  name: string;
  url: string;
  tags?: string[];
  transform?: TransformType;
  bounds?: IMeshBounds;
  deleted: boolean;
  /**
   * Canonical override: {@link MESH_INFO_MATERIAL_ORIGINAL_KEY},
   * {@link MESH_INFO_MATERIAL_ALUMINUM_KEY}, {@link MESH_INFO_MATERIAL_NORMALS_KEY}, or another
   * key from `manufacturer.materials`.
   */
  materialOverride?: string;
}
